import React from 'react';
import './ZodiacWheel.css';

const ZodiacWheel = () => {
  const stageStyle = {
    '--zw-stairs-outer': `url("${process.env.PUBLIC_URL}/images/legacy/stairs-ring.png")`,
    '--zw-stairs-inner': `url("${process.env.PUBLIC_URL}/images/legacy/stairs-half.png")`,
    '--zw-chakra':       `url("${process.env.PUBLIC_URL}/images/legacy/chakra-ring.png")`,
  };
  return (
  <section className="zw" id="zodiac-wheel" aria-label="VTD Astrology zodiac wheel">
    <div className="zw__inner">
      <p className="zw__eyebrow">Vedic Cosmos · 12 Rashis · Eternal Cycle</p>
      <h2 className="zw__title">
        Your Stars,<span className="zw__title-gold"> Your Story.</span>
      </h2>
      <p className="zw__sub">
        Every soul is born under a celestial map. Discover where you stand in the cosmic wheel
        — and how its motion shapes your past, present, and tomorrow.
      </p>

      <div className="zw__stage" style={stageStyle} aria-hidden="true">
        <div className="zw__stairs zw__stairs--outer" />
        <div className="zw__stairs zw__stairs--inner" />
        <div className="zw__chakra" />
        <img
          className="zw__wheel"
          src={`${process.env.PUBLIC_URL}/images/legacy/zodiac-wheel.png`}
          alt="VTD Astrology zodiac wheel"
        />
        <div className="zw__glow" />
      </div>

      <a href="/chat" className="zw__cta">
        Read My Chart — Chat with Tilak →
      </a>
    </div>
  </section>
  );
};

export default ZodiacWheel;
